<div class="tw-h-full tw-w-full tw-bg-gray-75 tw-flex tw-flex-col tw-gap-6 tw-p-6">
  @if (showQuestion()) {
    <app-quiz-progress-header
      [percent]="progressPercent()"
      [stepLabel]="stepLabel()"
      [showBack]="showBack()"
      [backDisabled]="backDisabled()"
      (back)="onBackClicked()"
      (closed)="onCloseClicked()" />
  }
  <div class="tw-flex-1 tw-min-h-0 tw-overflow-y-auto tw-flex tw-flex-col tw-gap-6">
    @if (showQuestion()) {
      <div class="tw-flex tw-flex-col tw-gap-2">
        @if (isPhotoInstructionMode() && photoPair.alternatePhoto(); as pairPhoto) {
          <app-quiz-photo-uploaded-strip
            [photoUrls]="[pairPhoto.url]"
            [checkupType]="pairPhoto.type"
            (opened)="onOpenPairPhoto()" />
        }
        <app-quiz-question-header [heading]="questionHeading()" [subText]="questionSubText()" />
      </div>
      @switch (quizService.layout()) {
        @case (QuizQuestionLayout.Text) {
          <app-quiz-text-answer
            [placeholder]="quizService.textPlaceholder()"
            [disabled]="inputsDisabled()"
            [showVoice]="showVoice()"
            [value]="restoredTextAnswer()"
            (valueChange)="onTypedTextChange($event)" />
        }
        @case (QuizQuestionLayout.MultiSelect) {
          <app-quiz-option-list
            [options]="quizService.buttonOptions()"
            [multiSelect]="true"
            [type]="optionListType()"
            [disabled]="inputsDisabled()"
            [selectedValues]="quizService.currentAnswer?.() ?? null"
            (selectionChange)="onSelectionChange($event)" />
        }
        @case (QuizQuestionLayout.PhotoReview) {
          <app-quiz-photo-review (capture)="onReviewCapture($event)" (openInstantCheckup)="onOpenInstantCheckup($event)" />
        }
        @case (QuizQuestionLayout.PhotoUpload) {
          <div class="tw-flex tw-flex-col tw-gap-4">
            <app-quiz-photo-upload
              [instructionImageUrl]="photoInstructionImageUrl()"
              (capture)="onContinue()"
              (openInstantCheckup)="onOpenInstantCheckup($event)" />
            @if (isPhotoInstructionMode()) {
              <div class="tw-flex tw-flex-col tw-gap-2">
                <app-quiz-footer-cta
                  [label]="ctaLabel()"
                  [icon]="ctaIcon()"
                  [disabled]="ctaDisabled()"
                  [loading]="isSubmittingAnswer()"
                  (pressed)="onContinue()" />
                @if (galleryUploadEnabled()) {
                  <button csButton="outlined"
                    id="galleryUploadCta"
                    type="button"
                    class="tw-w-full tw-max-w-full"
                    (click)="onGalleryUpload()"
                    i18n="@@uploadPhoto">Upload Photo</button>
                }
                <app-quiz-secure-photo-note />
              </div>
            }
          </div>
        }
        @default {
          @if (quizService.imageOptions().length) {
            <app-quiz-image-option-grid
              [options]="quizService.imageOptions()"
              [disabled]="inputsDisabled()"
              [showIndex]="showImageOptionIndex()"
              [selectedValue]="quizService.currentAnswer?.() ?? null"
              (selectionChange)="onImageSelectionChange($event)" />
          }
          @if (quizService.buttonOptions().length) {
            <app-quiz-option-list
              [options]="quizService.buttonOptions()"
              [type]="optionListType()"
              [disabled]="inputsDisabled()"
              [selectedValues]="quizService.currentAnswer?.() ?? null"
              (selectionChange)="onButtonSelectionChange($event)" />
          }
        }
      }
    } @else if (showLoading()) {
      <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center">
        <loading [size]="48" [stroke]="'var(--cureskin-teal-600)'"></loading>
      </div>
    }
    @if (quizService.errorMessage()) {
      <p class="tw-text-300 tw-text-red-500">{{ quizService.errorMessage() }}</p>
    }
  </div>
  <div class="tw-flex tw-flex-col tw-gap-2.5">
    @if (bothPhotosUploadedToastUrls().length) {
      <app-quiz-photo-uploaded-strip [photoUrls]="bothPhotosUploadedToastUrls()" />
    }
    @if (showQuestion() && !isPhotoInstructionMode()) {
      <app-quiz-footer-cta [label]="ctaLabel()" [icon]="ctaIcon()" [disabled]="ctaDisabled()" [loading]="isSubmittingAnswer()" (pressed)="onContinue()" />
    }
  </div>
</div>
